export const CONTAINERS = {
  LOGGED: 'ae-duda-container-logged',
  UNLOGGED: 'ae-duda-container-unlogged',
  USERNAME: 'ae-duda-container-username',
}
